import { Listbox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid'

export default function ProgramLevelDropdown({
    allowAll = true,
    programLevelHashMap={},
    selectedProgramLevel,
    setSelectedProgramLevel
}) {
    if (
        programLevelHashMap === null 
        || Object.keys(programLevelHashMap).length === 0
    ) {
        return null
    }

    return (
        <Listbox
            value={selectedProgramLevel}
            onChange={setSelectedProgramLevel}
        >
            <div className='relative w-full'>
                <Listbox.Button className='relative flex h-10 w-full items-center cursor-pointer rounded-lg border border-gray-300 bg-white pl-3 pr-10 text-left text-sm shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 shadow-md'>
                    {(() => {
                        const selected = programLevelHashMap[selectedProgramLevel]

                        return (
                            <span className='flex items-center'>
                                <span className='block truncate'>
                                    {selected ? selected.name : (allowAll ? 'All levels' : 'Select level')}
                                </span>
                            </span>
                        )
                    })()}

                    <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                        <ChevronUpDownIcon className='h-5 w-5 text-gray-400' />
                    </span>
                </Listbox.Button>

                <Transition
                    as="div"
                    leave='transition ease-in duration-100'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <Listbox.Options className='absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none'>
                        {allowAll &&
                            <Listbox.Option
                                value='all'
                                className={({ active }) =>
                                    `relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? 'bg-orange-50' : ''}`
                                }
                            >
                                {({ selected }) => (
                                    <>
                                        <span className='flex items-center gap-x-2'>
                                            <span className='h-3 w-3 flex-shrink-0 rounded-full bg-gray-400' />
                                            <span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                All levels
                                            </span>
                                        </span>

                                        {selected &&
                                            <span className='absolute inset-y-0 right-0 flex items-center pr-2 text-orange-600'>
                                                <CheckIcon className='h-5 w-5' />
                                            </span>
                                        }
                                    </>
                                )}
                            </Listbox.Option>
                        }

                        {Object.entries(programLevelHashMap)
                            .sort(([, a], [, b]) => a.sortOrder - b.sortOrder)
                            .map(([programLevelId, programLevel]) => (
                                <Listbox.Option
                                    key={programLevelId}
                                    value={parseInt(programLevelId)}
                                    className={({ active }) =>
                                        `relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? 'bg-orange-50' : ''}`
                                    }
                                >
                                    {({ selected }) => (
                                        <>
                                            <span className='flex items-center'>
                                                <span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                    {programLevel.name}
                                                </span>
                                            </span>

                                            {selected &&
                                                <span className='absolute inset-y-0 right-0 flex items-center pr-2 text-orange-600'>
                                                    <CheckIcon className='h-5 w-5' />
                                                </span>
                                            }
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}